import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()
  const { logout } = useAuth()

  const handleGoHome = () => {
    logout().then(() => navigate('/'))
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
      <Typography variant="h1" color="primary" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" color="textSecondary" gutterBottom>
        Page Not Found
      </Typography>
      <Button variant="contained" color="primary" onClick={handleGoHome}>
        Go to Home Page
      </Button>
    </Box>
  )
}

export default NotFoundPage
